export default "/_next/static/chunks/fonts/HK Grotesk Medium-66023ce7e5d6cfcfea1f7b3e65fdfd88.otf";